// extracted by mini-css-extract-plugin
export var onetrustButton = "SubFooterNav-module--onetrust-button--f7374";
export var subFooterNav = "SubFooterNav-module--sub-footer-nav--a0d3f";